// src/components/ads/adContext/adContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAds } from '../../../store/thunks/common-thunks/commonThunk';

//  Create the context 
export const AdContext = createContext();


// Create the Provider component
export const AdProvider = ({ children }) => {
  const dispatch = useDispatch();
  const {adsList} = useSelector(state => state.ads)
  useEffect(() => {
    const initializeAds = async () => {
      try {
        dispatch(getAds());
             } catch (error) {
        console.error("Failed to initialize ads:", error);
          }
    };
    
    initializeAds();
  }, [dispatch]);

  
  const value = { adsList };
  
  // 4. Use AdContext.Provider (which is now defined)
  return <AdContext.Provider value={value}>{children}</AdContext.Provider>;
};

// 5. Create the hook
export const useAdContext = () => {
  const context = useContext(AdContext);
  if (context === undefined) {
    throw new Error('useAdContext must be used within an AdProvider');
  }
  return context;
};

// Export everything from a single file
export default {
  AdContext,
  AdProvider,
  useAdContext,
};